import Splide from "@splidejs/splide";

export default class TechnologyCarousel {
    static init(): void {
        const splide: HTMLElement | null = document.querySelector(".technology-carousel__items-wrapper");
        if (!splide) return;
        const count = splide.querySelectorAll(".splide__slide").length;

        new Splide(splide, {
            type: count >= 3 ? "loop": "slide",
            gap: "1rem",
            updateOnMove: true,
            pagination: false,
            speed: 400,
            clones: 3,
        }).mount();
    }
}
